function disableBodyOverflow(disable) {
    const hiddenStyle = 'overflow-y:hidden!important;';
    const currentStyle = document.body.getAttribute('style') || '';
    if (disable) {
        document.body.setAttribute('style', `${hiddenStyle}${currentStyle}`);
    }
    else {
        document.body.setAttribute('style', currentStyle.replace(hiddenStyle, ''));
    }
}

export { disableBodyOverflow };
//# sourceMappingURL=disableBodyOverflow.js.map
